// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2Dua7","large":"styles_large__cFKVV"};